import React from 'react';
import { Button } from '@material-ui/core';
import { CloseIcon } from '../../../../common/icon';
import translate from '../../../../../i18n/translate';

interface NoteEditorProps {
  handleEditCloseView: () => void;
  isWordNoteUpdated: boolean;
  notes: string;
  setNotes: (notes: string) => void;
  handleNoteSaveEvent: () => void;
}

const NoteEditor: React.FC<NoteEditorProps> = ({
  handleEditCloseView,
  isWordNoteUpdated,
  notes,
  setNotes,
  handleNoteSaveEvent,
}) => {
  return (
    <div className="note-container">
      <div className="close-icon-container">
        <CloseIcon className="close-icon" onClick={handleEditCloseView} />
      </div>
      {isWordNoteUpdated ? (
        <div className="notes-updated-message-box">
          <p className="note-updated-message-para">{translate("vocab_center_note_updated_message")}</p>
        </div>
      ) : (
        <>
          <p className="note-label">{translate("vocab_center_note_label")}:</p>
          <textarea
            className="note-comments-textarea"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
          <div className="note-container-actions">
            <Button
              variant="contained"
              className="save-button"
              onClick={handleNoteSaveEvent}
              disabled={notes.length === 0}
            >
              {translate("vocab_center_save_text")}
            </Button>
            <Button variant="contained" className="close-button" onClick={handleEditCloseView}>
              {translate("vocab_center_close_text")}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default NoteEditor;